module.exports = __webpack_public_path__ + "static/media/gradient.ea54a695.jpg";